export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9054.be23de22.jpg";